import InfoMeType from "./actionTypes"

const INIT_STATE = {
  data: {
    loading: true,
    data: {}
  }
}

const InfoMe = (state = INIT_STATE, action) => {
  switch (action.type) {
    case InfoMeType.GET_INFO_ME_2_SUCCESS:
      return {
        ...state,
        data: action.payload,
      }
    default:
      return state
  }
}

export default InfoMe
